import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import { TextCustom, TextCustomProps, TextLineHeight,TextSize } from '@vw-marketing/us-components';

export const ContentListItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  ${({ theme }) => {
    return `
      gap: ${theme.size.static200};
    `;
  }}
`;

export const ContentListItemStyled = styled(TextCustom)<TextCustomProps>``;

ContentListItemStyled.defaultProps = {
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24
    },
    
    [Breakpoints.b1920]: {
      fontSize: TextSize.TextSize20,
      lineHeight: TextLineHeight.TextLineHeight32
    },
  }
};